import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { GoogleMap } from '@angular/google-maps';
import { GoogleMapsModule } from '@angular/google-maps';
import { ActivatedRoute, Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { Location } from '@angular/common';

@Component({
  selector: 'app-tracking-maps-detail',
  imports: [
    GoogleMapsModule,
    MatIconModule,
    CommonModule
  ],
  templateUrl: './tracking-maps-detail.component.html',
  styleUrl: './tracking-maps-detail.component.scss'
})
export class TrackingMapsDetailComponent implements AfterViewInit {
  selectedOrder: any = {};
  currentLocation: google.maps.LatLngLiteral | null = null;
  screenHeight: number = window.innerHeight - 80;

  markers: google.maps.marker.AdvancedMarkerElement[] = [];

  @ViewChild(GoogleMap, { static: false }) map!: GoogleMap;
  mapOptions: google.maps.MapOptions = {
    zoom: 14,
    center: { lat: 0, lng: 0 }, // Default center
  };

  // from = { lat: 11.5271361, lng: 104.9175269 };
  // to = { lat: 11.854646, lng: 104.7243412 };
  from = { lat: 0, lng: 0 };
  to = { lat: 0, lng: 0 };
  currentTruckLocation = { lat: 11.760235030155075, lng: 104.82685755066548 }; // 
  center: google.maps.LatLngLiteral = this.currentTruckLocation;//11.5618378,104.8715408
  carIcon = {
    url: 'assets/img/car-location.png', // Use a car icon
    scaledSize: new google.maps.Size(40, 55), // Resize icon
  };
  warehouseIcon = {
    url: 'assets/img/start-orange.png', // Use a car icon
    scaledSize: new google.maps.Size(40, 55), // Resize icon
  };
  destinationIcon = {
    url: 'assets/img/destination-orange.png', // Use a car icon
    scaledSize: new google.maps.Size(50, 55), // Resize icon
  };

  directionsService = new google.maps.DirectionsService();
  directionsRendererStartToCar!: google.maps.DirectionsRenderer;
  directionsRendererCarToEnd!: google.maps.DirectionsRenderer;

  constructor(private route: ActivatedRoute, private router: Router, private location: Location) { }
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.selectedOrder = JSON.parse(params["data"]);
    });
  }

  ngAfterViewInit() {
    this.from = { lat: parseFloat(this.selectedOrder.from.lat), lng: parseFloat(this.selectedOrder.from.lng) }
    this.to = { lat: parseFloat(this.selectedOrder.to.lat), lng: parseFloat(this.selectedOrder.to.lng) }
    this.currentTruckLocation = { lat: parseFloat(this.selectedOrder.truckLocation.lat), lng: parseFloat(this.selectedOrder.truckLocation.lng) }
    this.center = this.currentTruckLocation;
    this.directionsRendererStartToCar = new google.maps.DirectionsRenderer({
      polylineOptions: { strokeColor: '#bbb', strokeWeight: 5 },
      suppressMarkers: true
    });

    this.directionsRendererCarToEnd = new google.maps.DirectionsRenderer({
      polylineOptions: { strokeColor: 'blue', strokeWeight: 5 },
      suppressMarkers: true
    });

    this.directionsRendererStartToCar.setMap(this.map.googleMap!);
    this.directionsRendererCarToEnd.setMap(this.map.googleMap!);

    this.drawRoutes();
  }

  drawRoutes() {
    // Route from start to car location (Blue)
    this.directionsService.route(
      {
        origin: this.from,
        destination: this.currentTruckLocation,
        travelMode: google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === google.maps.DirectionsStatus.OK) {
          this.directionsRendererStartToCar.setDirections(result);
        } else {
          console.error('Failed to get route from start to car:', status);
        }
      }
    );

    // Route from car location to end (Gray)
    this.directionsService.route(
      {
        origin: this.currentTruckLocation,
        destination: this.to,
        travelMode: google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === google.maps.DirectionsStatus.OK) {
          this.directionsRendererCarToEnd.setDirections(result);
        } else {
          console.error('Failed to get route from car to end:', status);
        }
      }
    );
  }

  onMapClick(event: google.maps.MapMouseEvent) {
    if (event.latLng) {
      const marker = new google.maps.marker.AdvancedMarkerElement({
        position: { lat: event.latLng.lat(), lng: event.latLng.lng() },
        title: `Marker ${this.markers.length + 1}`
      });
      console.log("Location: ", event.latLng.lat(), ", long: ", event.latLng.lng())
      this.markers = [marker]
    }
  }

  goBack() {
    this.location.back();
  }

  centerOnTruck() {
    if (this.map?.googleMap) {
      this.map.googleMap.panTo(this.currentTruckLocation);
      this.map.googleMap.setZoom(15);
    }
  }

  fitAllMarkers() {
    if (this.map?.googleMap) {
      const bounds = new google.maps.LatLngBounds();
      bounds.extend(this.from);
      bounds.extend(this.currentTruckLocation);
      bounds.extend(this.to);
      this.map.googleMap.fitBounds(bounds, 50);
    }
  }
}
